import React from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";
import { NumericFormat } from "react-number-format";
import { Error, Success } from "../../../assets/jss/util/messageUtil";

export default function Themtuyenxebuyt() {
  const [matuyen, setMatuyen] = React.useState("");
  const [tentuyen, setTentuyen] = React.useState("");
  const [diemdau, setDiemdau] = React.useState([]);
  const [diemcuoi, setDiemcuoi] = React.useState("");
  const [lotrinh, setLotrinh] = React.useState("");
  const [culy, setCuly] = React.useState(0);
  const [tinhtrang, setTinhtrang] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  const inserttuyenxe = () => {
    let mess = validateThem();
    if (mess === Success.SC0001) {
      var url = Config.backend + "/api/Tuyen/themtuyenxebuyt";
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          matuyen: matuyen,
          tentuyen: tentuyen,
          diemdau: diemdau,
          diemcuoi: diemcuoi,
          lotrinh: lotrinh,
          culy: culy,
          tinhtrang: tinhtrang,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data === 1) {
            showNotification();
          } else showNotification1();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  const validateThem = () => {
    // Kiem tra cac truong bat buoc nhap
    if (matuyen.trim() === "") {
      return Error.ER0002;
    }
    if (tentuyen.trim() === "") {
      return Error.ER0003;
    }
    return Success.SC0001;
  };
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Mã tuyến"
                variant="outlined"
                value={matuyen}
                size="small"
                onChange={(event) => {
                  setMatuyen(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Tên tuyến"
                variant="outlined"
                value={tentuyen}
                size="small"
                onChange={(event) => {
                  setTentuyen(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Điểm đầu"
                variant="outlined"
                value={diemdau}
                size="small"
                onChange={(event) => {
                  setDiemdau(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Điểm cuối"
                variant="outlined"
                value={diemcuoi}
                size="small"
                onChange={(event) => {
                  setDiemcuoi(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Lộ trình"
                variant="outlined"
                value={lotrinh}
                size="small"
                onChange={(event) => {
                  setLotrinh(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <NumericFormat
                label="Cự ly tuyến (km)"
                variant="outlined"
                size="small"
                value={culy}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setCuly(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Tình trạng"
                variant="outlined"
                value={tinhtrang}
                size="small"
                onChange={(event) => {
                  setTinhtrang(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "20px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          onClick={inserttuyenxe}
        >
          Thêm
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Thêm thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình thêm"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}
